// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","blue":"_10nHZJx","white":"_3JdB7nN","transition":"\"css/base/transition.css\"","transition-default":"0.2s","icon":"_1Mn-Cfz","outer":"ukYZmug"};